const services = [
  {
    icon: 'ri-home-4-line',
    title: 'Residential Hauling',
    description: 'Clearing out your home, garage, or yard? We handle furniture, appliances, yard waste, and everything in between.',
    features: ['Furniture Removal', 'Appliance Disposal', 'Garage Cleanouts']
  },
  {
    icon: 'ri-building-2-line',
    title: 'Commercial Cleanouts',
    description: 'Office renovations, retail cleanouts, or warehouse clearing—we have the equipment and manpower to get it done.',
    features: ['Office Furniture', 'Retail Fixtures', 'Warehouse Debris']
  },
  {
    icon: 'ri-home-heart-line',
    title: 'Home Staging Prep',
    description: 'Preparing to sell your home? We help declutter and remove unwanted items to showcase your property at its best for potential buyers.',
    features: ['Pre-Sale Decluttering', 'Staging Preparation', 'Quick Turnaround']
  },
  {
    icon: 'ri-tools-line',
    title: 'Construction Debris',
    description: 'Post-construction cleanup made easy. We remove drywall, lumber, concrete, and all types of building materials.',
    features: ['Drywall & Lumber', 'Concrete Removal', 'Site Cleanup']
  },
  {
    icon: 'ri-leaf-line',
    title: 'Yard Waste Removal',
    description: 'Branches, leaves, dirt, and landscaping debris—we\'ll haul it all away and leave your property spotless.',
    features: ['Tree Branches', 'Lawn Debris', 'Soil & Dirt']
  },
  {
    icon: 'ri-timer-flash-line',
    title: 'Same-Day Service',
    description: 'Need it gone today? We offer same-day pickup for urgent jobs. Call us and we\'ll be there fast.',
    features: ['Quick Response', 'Flexible Scheduling', 'Emergency Pickup']
  },
  {
    icon: 'ri-recycle-line',
    title: 'Eco-Friendly Disposal',
    description: 'We care about the environment. Items are recycled, donated, or disposed of responsibly whenever possible.',
    features: ['Recycling', 'Donation Drop-off', 'Proper Disposal']
  }
];

export default function Services() {
  return (
    <section id="services" className="relative py-24 bg-[#0a0a0a] overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#3D3225]/30 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full mb-6">
            <i className="ri-truck-line text-[#D4AF37]"></i>
            <span className="text-[#D4AF37] text-sm font-medium tracking-wider">WHAT WE HAUL</span>
          </div>
          <h3 className="font-['Orbitron'] text-4xl sm:text-5xl font-bold text-white mb-4">
            Our <span className="text-[#D4AF37]">Services</span>
          </h3>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            From single items to full property cleanouts, we handle it all with professionalism and care.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative p-8 bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-gray-800 hover:border-[#D4AF37]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#D4AF37]/10"
            >
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-xl mb-6 group-hover:bg-[#D4AF37]/20 transition-colors">
                <i className={`${service.icon} text-3xl text-[#D4AF37]`}></i>
              </div>

              {/* Content */}
              <h4 className="font-['Orbitron'] text-xl font-bold text-white mb-3">
                {service.title}
              </h4>
              <p className="text-gray-400 mb-6 leading-relaxed">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-300">
                    <i className="ri-check-line text-[#D4AF37]"></i>
                    {feature}
                  </li>
                ))}
              </ul>

              {/* Hover Accent */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-[#D4AF37]/5 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-black font-bold rounded-lg hover:bg-[#E5C158] transition-all hover:shadow-lg hover:shadow-[#D4AF37]/30 cursor-pointer whitespace-nowrap"
          >
            <span>Get Your Free Quote</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
